import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';

export enum EUserRoute {
  user = 'user',
  myprofile = 'my-profile',
  tenant = 'tenant',
  owner = 'owner',
}

TaRoutes.addRoute({
  key: EUserRoute.user,
  url: 'user',
  children: [
    {
      key: EUserRoute.myprofile,
      url: 'my-profile',
    },
    {
      key: EUserRoute.tenant,
      url: 'tenant',
    },
    {
      key: EUserRoute.owner,
      url: 'owner',
    },
  ],
});

export const userRoutes: Routes = [
  {
    path: TaRoutes.getUrl([EUserRoute.user, EUserRoute.myprofile]),
    title: 'app.pages.my_profile.title',
    loadComponent: () => import('./pages/profile/profile').then((c) => c.ProfilePage),
  },
  {
    path: TaRoutes.getUrl([EUserRoute.user, EUserRoute.tenant]),
    title: 'app.pages.tenant_profile.title',
    loadComponent: () => import('./pages/tenant/tenant').then((c) => c.TenantPage),
  },
  {
    path: TaRoutes.getUrl([EUserRoute.user, EUserRoute.owner]),
    title: 'app.pages.owner_profile.title',
    loadComponent: () => import('./pages/owner/owner').then((c) => c.OwnerPage),
  },
];
